let BusinessIdentityProvider = /*#__PURE__*/function (BusinessIdentityProvider) {
  BusinessIdentityProvider["IZettle"] = "IZETTLE";
  BusinessIdentityProvider["PayPal"] = "PAYPAL";
  return BusinessIdentityProvider;
}({});

export { BusinessIdentityProvider };
//# sourceMappingURL=business-identity-provider.js.map
